import { v4 as uuid } from 'uuid';
import { filterVisibleAnswers } from './nodeEvaluation/visibleIf/filterVisibleAnswers';
import { evaluateConditions } from '../condition-engine/evaluateConditions';
import { evaluateQuery } from '../condition-engine/queries';
import { SetValueEffectSpecialValue } from '../types/carrierQuestionnaire/engineEffects';
export function processSetValueEffects(setValueEffects, changedAnswer, answersResolver, dependencyMap, scope, timezone, applicationContext, currentDateOverride) {
    if (!setValueEffects) {
        return;
    }
    const changedNodeIds = setValueEffects
        .map((effect) => {
        const { at, value, newAnswerMustMatch, triggerIf } = effect;
        if (newAnswerMustMatch && !(newAnswerMustMatch === changedAnswer)) {
            return; // changedAnswer does not match, skip this effect.
        }
        if (triggerIf && !shouldApplyEffect(triggerIf, answersResolver, scope, timezone, currentDateOverride)) {
            return;
        }
        const valueToSet = resolveValueFromEffectValue(value, answersResolver, scope, timezone, currentDateOverride, applicationContext);
        const currentValue = answersResolver.usingNodeId().getAnswer(at, scope);
        if (valueToSet !== currentValue) {
            answersResolver.usingNodeId().setAnswer(valueToSet, at, scope);
            return at;
        }
    })
        .filter(Boolean);
    filterVisibleAnswersAfterEffectChanges(changedNodeIds, answersResolver, dependencyMap, scope, timezone, currentDateOverride);
}
function filterVisibleAnswersAfterEffectChanges(nodeIds, answersResolver, dependencyMap, scope, timezone, currentDateOverride) {
    for (const nodeId of nodeIds) {
        filterVisibleAnswers(nodeId, dependencyMap, answersResolver, scope, timezone, currentDateOverride);
    }
}
function shouldApplyEffect(triggerIf, answersResolver, scope, timezone, currentDateOverride) {
    return evaluateConditions(triggerIf, answersResolver, scope, timezone, currentDateOverride).isValid;
}
function resolveValueFromEffectValue(effectValue, answersResolver, scope, timezone, currentDateOverride, applicationContext) {
    if (effectValue === SetValueEffectSpecialValue.newId)
        return uuid();
    if (isQueryEffectValue(effectValue)) {
        const queryEffectValue = evaluateQuery(effectValue, answersResolver, scope, timezone, applicationContext, currentDateOverride);
        if (typeof queryEffectValue !== 'string' &&
            typeof queryEffectValue !== 'boolean' &&
            typeof queryEffectValue !== 'number' &&
            typeof queryEffectValue !== 'undefined') {
            return;
        }
        return queryEffectValue;
    }
    return effectValue;
}
function isQueryEffectValue(effectValue) {
    return !!effectValue && !!effectValue.select;
}
